import { FC } from 'react'
import { useSelector } from 'react-redux'
import { getOraclePrices } from '../../redux/modules/app'
import { calculateArbAmount, getCollateralAsNumber } from '../../utils/helpers'
import { CssTextField } from '../OpenLoan/OpenLoan'

interface propsState {
  amount: string
}

export const ArbBananasEstimate: FC<propsState> = (props) => {
  const oraclePrices = useSelector(getOraclePrices)

  return (
    <CssTextField
      variant="outlined"
      fullWidth={true}
      type={'text'}
      label="Est. KONG Received"
      id="loan-amount"
      value={calculateArbAmount(
        getCollateralAsNumber(props.amount),
        oraclePrices.KONG_USD,
        'BANANA'
      )}
    />
  )
}
